import { useEffect } from 'react';

interface UseCombineClientsModalEffectsProps {
  initialModal(): void;
}

export const useCombineClientsModalEffects = ({
  initialModal,
}: UseCombineClientsModalEffectsProps) => {
  useEffect(() => {
    initialModal();
  }, [initialModal]);
};
